import { useEffect, useRef, useState } from "react";
import "../../styles/UserDashboard/OnboardingTemplate.scss";
import {
  Autocomplete,
  Box,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import {
  submitGovernanceTemplate,
} from "../../apis/General/users";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector } from "react-redux";
import projectDscDocument from "../../documents/CLOSECARBON PROJECT DESCRIPTION TEMPLATE.docx";
import baseYearInventoryDocument from "../../documents/Organization Base-year GHG Inventory Template.xlsx";
import { countries } from "../../data/countries";
import Web3 from "web3";
import Web3Modal from "web3modal";
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";
import { useWeb3Modal } from "@web3modal/ethers/react";
import {
  useWeb3ModalProvider,
  useWeb3ModalAccount,
} from "@web3modal/ethers/react";
import { BrowserProvider, Contract, formatUnits } from "ethers";

export default function GovernanceOnboardingTemplates() {
  const auth = useSelector((state) => state.auth);
  const pathname = useLocation();
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [industry, setIndustry] = useState("");
  const [fuelSource, setFuelSource] = useState("nil");
  const [facilityCategory, setFacilityCategory] = useState("");
  const [greenProjectName, setGreenProjectName] = useState("");
  const [greenProjectLocation, setGreenProjectLocation] = useState("");
  const [greenProjectObjective, setGreenProjectObjective] = useState("");
  const [greenProjectStartDate, setGreenProjectStartDate] = useState("");
  const [greenProjectEndDate, setGreenProjectEndDate] = useState("");
  const [greenProjectLicenseId, setGreenProjectLicenseId] = useState("");
  const [greenCertificateBody, setGreenCertificateBody] = useState("");
  const [renewableEnergySolutions, setRenewableEnergySolutions] = useState("");
  const [facilityCapacity, setFacilityCapacity] = useState("");
  const [sustainabilitySolution, setSustainabilitySolution] = useState("");
  const [facilitySystemCapacity, setFacilitySystemCapacity] = useState("nil");
  const [walletAddress, setWalletAddress] = useState("");
  const [filled, setFilled] = useState(false);
  const [projectDescriptionReport, setProjectDescriptionReport] = useState("");
  const [quantifiedBaseYearInventory, setQuantifiedBaseYearInventory] =
    useState("");
  const [documentType, setDocumentType] = useState("");
  const [uplaodLoading, setUploadLoading] = useState(false);
  const mediaRef = useRef(null);
  const [images, setImages] = useState([]);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorText, setErrorText] = useState("hello");
  const [errorTitle, setErrorTitle] = useState("hello");
  const [errorButtonAction, setErrorButtonAction] = useState("login");
  const [userId, setUserId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [country, setCountry] = useState("");
  const [governmentOrganization, setGovernmentOrganization] = useState("");
  const [regulatoryStatus, setRegulatoryStatus] = useState("");
  const [facilityCapacityValue, setFacilityCapacityValue] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    if (
      companyName?.length > 0 &&
      industry?.length > 0 &&
      facilityCategory?.length > 0 &&
      firstName?.length > 0 &&
      lastName?.length > 0 &&
      email?.length > 0 &&
      country?.length > 0 &&
      governmentOrganization?.length > 0 &&
      regulatoryStatus?.length > 0 &&
      walletAddress?.length > 0
    ) {
      setFilled(true);
    } else {
      setFilled(false);
    }
  }, [
    companyName,
    industry,
    facilityCategory,
    firstName,
    lastName,
    email,
    country,
    governmentOrganization,
    regulatoryStatus,
    walletAddress
  ]);
  const handleShowError = (title, body, action = "ok") => {
    setErrorTitle(title);
    setErrorText(body);
    setErrorButtonAction(action);
    handleErrorModalOpen();
  };



  const handleGovernanceSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (!/^(0x)[0-9a-f]{40}$/i.test(walletAddress)) {
      alert("Invalid wallet address");
      setLoading(false);
      return false;
    } else {
      const response = await submitGovernanceTemplate(
        firstName,
        lastName,
        email,
        country,
        companyName,
        governmentOrganization,
        industry,
        facilityCategory,
        regulatoryStatus,
        walletAddress,
        pathname?.pathname?.split('/')[2]
      );

      if (response?.data?.statusCode === 200) {
        // toast.success(response?.data?.message);
        navigate(`/signup/${response.data.message}`);
        localStorage.setItem("demosent", "true");
      } else if (
        response?.data?.message ===
        "This email has been registered. Kindly login"
      ) {
        handleShowError(
          "Oops email already registered",
          "It appears this email has already been registered. If you’ve forgotten your password, click “Forgot Password” on the login screen.",
          "login"
        );
      } else if (
        response?.data?.message === "KYC submitted. Kindly verify your email."
      ) {
        handleShowError(
          "Oops email already existed",
          "This email already exists. Kindly click the button below to input the otp sent to your email to activate or request for a new OTP",
          "otp"
        );
        setUserId(response?.data?.userId);
      } else if (
        response?.data?.message ===
        "This email has been registered. Kindly complete the sign up process"
      ) {
        handleShowError(
          "Oops email already registered",
          "It appears this email has already been registered.  Kindly click the button below to complete the sign up process",
          "register"
        );
        setUserId(response?.data?.userId);
      } else {
        toast.error(response?.data?.message);
      }

      console.log("response governance", response);
    }

    setLoading(false);
  };



  const clickFileUpload = (e, documentTypeSent) => {
    setUploadLoading(true);

    let files = e.target.files;
    let allUploadedFiles = images;

    const fileToUri = (file, cb) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(null, reader.result);
      };
      reader.onerror = function (error) {
        cb(error, null);
      };
    };

    if (files) {
      for (let i = 0; i < files.length; i++) {
        fileToUri(files[0], (err, result) => {
          if (result) {
            console.log("result", result);
            if (documentTypeSent === "projectDescriptionReport") {
              axios
                .post(
                  `${process.env.REACT_APP_API_URL}/open/v1/upload`,
                  {
                    media_type: "docx",
                    folder: "word_documents",
                    user_id: auth?.userInfo?.id,
                    contents: [result],
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${auth ? auth.token : ""}`,
                    },
                  }
                )
                .then((response) => {
                  console.log("response file uploaded", response);
                  if (response?.data?.body?.success === true) {
                    if (documentTypeSent === "projectDescriptionReport") {
                      setProjectDescriptionReport(
                        response?.data?.body?.data[0]
                      );
                    } else if (
                      documentTypeSent === "quantifiedBaseYearInventory"
                    ) {
                      setQuantifiedBaseYearInventory(
                        response?.data?.body?.data[0]
                      );
                    } else {
                      toast.error("document type not specified");
                    }
                  }
                  setUploadLoading(false);
                })
                .catch((err) => {
                  setUploadLoading(false);
                });
            } else if (documentTypeSent === "quantifiedBaseYearInventory") {
              axios
                .post(
                  `${process.env.REACT_APP_API_URL}/open/v1/upload`,
                  {
                    media_type: "xlsx",
                    folder: "spreadsheets",
                    user_id: auth?.userInfo?.id,
                    contents: [result],
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${auth ? auth.token : ""}`,
                    },
                  }
                )
                .then((response) => {
                  console.log("response file uploaded", response);
                  if (response?.data?.body?.success === true) {
                    if (documentTypeSent === "projectDescriptionReport") {
                      setProjectDescriptionReport(
                        response?.data?.body?.data[0]
                      );
                    } else if (
                      documentTypeSent === "quantifiedBaseYearInventory"
                    ) {
                      setQuantifiedBaseYearInventory(
                        response?.data?.body?.data[0]
                      );
                    } else {
                      toast.error("document type not specified");
                    }
                  }
                  setUploadLoading(false);
                })
                .catch((err) => {
                  setUploadLoading(false);
                });
            }
          }
        });
      }
    }
  };

  const handleErrorModalClose = (e) => {
    if (e.target.classList.contains("errorModal")) {
      setErrorModalOpen(false);
    }
  };

  const handleErrorModalOpen = () => {
    setErrorModalOpen(true);
  };

  const handleProjectDescriptionDownload = () => {
    const link = document.createElement("a");
    link.href = projectDscDocument;
    link.download = "CLOSECARBON PROJECT DESCRIPTION TEMPLATE.docx"; // Set the desired file name for the download
    link.click();
  };
  const handleDownloadbaseYearInventoryDocument = () => {
    const link = document.createElement("a");
    link.href = baseYearInventoryDocument;
    link.download = "Organisation Base-year GHG Inventory Template.xlsx"; // Set the desired file name for the download
    link.click();
  };




  return (
    <div className="onboarding-template">
      <div className="onboarding-template__title">
        Almost there! Tell us about your facility for a perfect fit.      </div>
      <div className="onboarding-template__subtitle">
        Fill this simple form to enable us learn about your facility.
      </div>
      {/* <div className="steps">
        <div className="circle circle_active">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.75 8.75L6.25 12.25L13.25 4.75"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div className="line"></div>
        <div className={filled ? "circle circle_active" : "circle"}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.75 8.75L6.25 12.25L13.25 4.75"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div> */}
      {stage === 1 && (
        <form onSubmit={handleGovernanceSubmit}>
          <label className="onboarding-template__input-label  " htmlFor="name">
            First name
          </label>

          <input
            className="onboarding-template__input"
            required
            id="name"
            type="text"
            placeholder="Enter your first name"
            name="name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <label className="onboarding-template__input-label" htmlFor="name">
            Last name
          </label>

          <input
            className="onboarding-template__input"
            required
            id="name"
            type="text"
            placeholder="Enter your last name"
            name="name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <label className="onboarding-template__input-label" htmlFor="email">
            Email
          </label>

          <input
            className="onboarding-template__input"
            required
            id="email"
            type="email"
            placeholder="Enter email address"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label
            className="onboarding-template__input-label"
            htmlFor="lastName"
          >
            Company name
          </label>

          <input
            className="onboarding-template__input"
            required
            id="companyName"
            type="text"
            placeholder="Your company name"
            name="companyName"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />


          <label
            className="onboarding-template__input-label"
            htmlFor="lastName"
          >
            Country
          </label>

          <select
            className="onboarding-template__input onboarding-template__input-select"
            required
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          >
            <option value="">Select country</option>
            {countries?.map((country) => (
              <option value={country?.label}>{country?.label}</option>
            ))}
          </select>

          <label
            className="onboarding-template__input-label"
            htmlFor="lastName"
          >
            Government organisation
          </label>

          <select
            className="onboarding-template__input onboarding-template__input-select"
            required
            value={governmentOrganization}
            onChange={(e) => setGovernmentOrganization(e.target.value)}
          >
            <option value="">Are you a government owned organisation</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>




          <label
            className="onboarding-template__input-label"
            htmlFor="industry"
          >
            Industry
          </label>

          <input
            className="onboarding-template__input"
            required
            id="industry"
            type="text"
            placeholder="Enter the industry your company falls under e.g food industry, oil and gas"
            name="industry"
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
          />


          <label
            className="onboarding-template__input-label"
            htmlFor="facilityCategory"
          >
            Facility category
          </label>

          <select
            className="onboarding-template__input onboarding-template__input-select"
            required
            value={facilityCategory}
            onChange={(e) => setFacilityCategory(e.target.value)}
          >
            <option value="">Select a facility category</option>
            <option value="green">Green</option>
            <option value="non-green">Non-green</option>
            <option value="carbon-monitoring">Monitoring</option>
          </select>

          <label
            className="onboarding-template__input-label"
            htmlFor="facilityCategory"
          >
            Regulatory status
          </label>

          <select
            className="onboarding-template__input onboarding-template__input-select"
            required
            value={regulatoryStatus}
            onChange={(e) => setRegulatoryStatus(e.target.value)}
          >
            <option value="">Select your regulatory status</option>
            <option value="non-regulator">Non-regulator</option>
            <option value="regulator">Regulator</option>
          </select>


          <label className="onboarding-template__input-label" htmlFor="phone">
            Wallet address
          </label>
          <div className="onboarding-template__info">
            You can create a wallet and get an address on the <a href="https://metamask.io/" target="_blank" >MetaMask</a> website
          </div>
          <input
            className="onboarding-template__input"
            required
            id="walletAddress"
            type="text"
            placeholder="Enter your Ethereum Wallet Address (e.g., 0x1234...abcd)"
            name="walletAddress"
            value={walletAddress}
            onChange={(e) => setWalletAddress(e.target.value)}
          />

          <div className="onboarding-template__input-text">
            Note: Do not disclose your private key.
          </div>
          <div className="onboarding-template__container">
            <div className="onboarding-template__checkbox-wrapper">
              {!termsAccepted && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setTermsAccepted(true)}
                  style={{ cursor: 'pointer' }}
                >
                  <rect x="1.5" y="1.5" width="21" height="21" rx="5" stroke="url(#paint0_linear_2889_18043)" strokeWidth="1.5" />
                  <defs>
                    <linearGradient id="paint0_linear_2889_18043" x1="1.5" y1="1.82" x2="26.76" y2="14.38" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#006633" />
                      <stop offset="1" stopColor="#02A4CC" />
                    </linearGradient>
                  </defs>
                </svg>
              )}

              {termsAccepted && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setTermsAccepted(false)}
                  style={{ cursor: 'pointer' }}
                >
                  <rect x="1.5" y="1.5" width="21" height="21" rx="5" stroke="url(#paint0_linear_2889_18037)" strokeWidth="1.5" />
                  <path d="M7 12.5L10.5 16L17 9" stroke="url(#paint1_linear_2889_18037)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <defs>
                    <linearGradient id="paint0_linear_2889_18037" x1="1.5" y1="1.82" x2="26.76" y2="14.38" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#006633" />
                      <stop offset="1" stopColor="#02A4CC" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_2889_18037" x1="7" y1="9.26" x2="17.03" y2="15.74" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#006633" />
                      <stop offset="1" stopColor="#02A4CC" />
                    </linearGradient>
                  </defs>
                </svg>
              )}
            </div>

            <label className="onboarding-template__label" style={{ cursor: 'pointer' }} onClick={() => setTermsAccepted(!termsAccepted)}>
              <span>I confirm that I have read and agree to the</span>
              <a href="/privacy-policy" className="onboarding-template__link">
                <span> Privacy Policy and Terms & Conditions </span>
              </a>
              <span>for CloseCarbon.</span>
            </label>
          </div>
          <button
            className="onboarding-template__button"
            type="submit"
            disabled={loading}
          >
            <div>{loading ? "Loading..." : "Done"}</div>
          </button>
        </form>
      )}


      {errorModalOpen && (
        <div className="errorModal" onClick={handleErrorModalClose}></div>
      )}
      {errorModalOpen && (
        <div className="error_modal">
          <div className="modal_title">{errorTitle}</div>

          <div className="modal_subtitle">{errorText}</div>
          {errorButtonAction === "login" ? (
            <button
              className="error_modal_button"
              type="submit"
              onClick={() => navigate("/login")}
              disabled={loading}
            >
              {loading ? "Loading..." : "Login"}
            </button>
          ) : errorButtonAction === "register" ? (
            <button
              className="error_modal_button"
              type="submit"
              onClick={() => navigate(`/signup/${userId}/3`)}
              disabled={loading}
            >
              {loading ? "Loading..." : "Okay"}
            </button>
          ) : errorButtonAction === "otp" ? (
            <button
              className="error_modal_button"
              type="submit"
              onClick={() => navigate(`/signup/${userId}`)}
              disabled={loading}
            >
              {loading ? "Loading..." : "Okay"}
            </button>
          ) : (
            <button
              className="error_modal_button"
              type="submit"
              onClick={() => setErrorModalOpen(false)}
              disabled={loading}
            >
              {loading ? "Loading..." : "Okay"}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
